<div class="container-fluid animated fadeIn">
	<div class="row flex-column align-items-center my-5">
		<!-- STEPS TITLE -->
		<div class="col-12 mb-4">
			<div class="wiz-title text-center">
				{{ 'document-upload-step4.pageTitle' | translate }}
			</div>
		</div>
		<!-- CARD -->
		<div class="col-12 col-xl-12">
			<eif-custom-stepper
				[steps]="steps"
				[currentStep]="currentStep">
			</eif-custom-stepper>

			<div class="simple-card top-line">
				<div class="row justify-content-center px-3 py-3 px-md-5 py-md-5">
					<div class="d-flex justify-content-center align-items-center valid-results">
						<div
							class="d-inline-flex align-items-center"
							[class.are-valid]="totalValidRecords > 0"
							[class.are-invalid]="totalValidRecords === 0">
							<div>
								<div class="info-img-wrap">
									@if (totalValidRecords > 0) {
										<div>
											<i class="fa-solid fa-check-circle"></i>
										</div>
									} @else {
										<div>
											<i class="fa-solid fa-times-circle"></i>
										</div>
									}
								</div>
							</div>
							<div class="ms-4">
								<div class="text-uppercase text-secondary">
									<span>{{ 'document-upload-step4.FinalDocumentOutcomeText1' | translate }}</span>
									<span
										class="tag mx-2 fw-bold"
										[class.is-success]="totalValidRecords > 0"
										[class.is-danger]="totalValidRecords === 0"
										data-e2e-documents-upload-step4-valid-total>
										{{ totalValidRecords }}
									</span>
									<span>{{ 'document-upload-step4.FinalDocumentOutcomeText2' | translate }}</span>
									<span
										class="tag is-light mx-2"
										data-e2e-documents-upload-step4-documents-total>
										{{ totalValidRecords + totalInvalidRecords }}
									</span>
									<span>{{ 'document-upload-step4.FinalDocumentOutcomeText3' | translate }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				@if (totalInvalidRecords > 0 || isPerformingRequest) {
					<div>
						<div class="divider"></div>
						<div class="p-4">
							<h6 class="is-label mt-4">{{ 'document-upload-step4.InvalidDocumentsList' | translate }}</h6>
							@if (showValidationResultsForConfirming()) {
								<eif-documents-upload-confirming-validation-result
									[validationResultRecords]="invalidDocumentRecords"
									[pagination]="tablePagination"
									[loading]="isPerformingRequest || isTableLoading"
									[filters]="tableFilters"
									[enableFilters]="true"
									[showPageSize]="true"
									(searchRequested)="onSearchRequested($event)">
								</eif-documents-upload-confirming-validation-result>
							}
							@if (showValidationResultsForFactoring()) {
								<eif-documents-upload-factoring-validation-result
									[validationResultRecords]="invalidDocumentRecords"
									[pagination]="tablePagination"
									[loading]="isPerformingRequest || isTableLoading"
									[filters]="tableFilters"
									[enableFilters]="true"
									[showPageSize]="true"
									(searchRequested)="onSearchRequested($event)">
								</eif-documents-upload-factoring-validation-result>
							}
						</div>
					</div>
				}
			</div>
			<!-- BUTTONS AREA -->
			<div class="d-flex align-items-center justify-content-xs-center justify-content-end py-4 gap-3">
				<eif-custom-button
					[color]="'neutral'"
					[text]="'button.back' | translate"
					(action)="redirectToDocumentsStep2()">
				</eif-custom-button>
				<eif-custom-button
					[text]="'document-upload-step4.goToDocuments' | translate"
					(action)="redirectToDocuments()">
				</eif-custom-button>
			</div>
		</div>
	</div>
</div>
